import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { SharedUser } from '../../../shared/models/user';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faHandWave } from '@fortawesome/pro-solid-svg-icons';
import { OdinService } from '../../services/odin.service';
import { AudioActivityService } from '../../services/audio-activity.service';
import { resolveAvatar } from '../../../shared/helpers/avatar';
import { muteStateOf } from '../../../shared/helpers/mute-state';
import { MuteStatus } from '../mute-status/mute-status';

@Component({
  selector: 'andor-user-avatar',
  standalone: true,
  imports: [FaIconComponent, MuteStatus],
  templateUrl: './user-avatar.html',
  styleUrl: './user-avatar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatar {
  private odin = inject(OdinService);
  private audioActivity = inject(AudioActivityService);

  user = input.required<SharedUser>();
  scale = input<number>(1.0);
  showStatus = input<boolean>(true);
  showActivity = input<boolean>(true);

  avatarUrl = computed(() => resolveAvatar(this.user().data.avatar, this.user().data.name));
  avatarStyle = computed(() => `transform: scale(${this.scale()})`);
  active = computed(
    () => this.showActivity() && this.audioActivity.audioActiveFor(this.user().id)()
  );
  // Picks the badge; andor-mute-status renders the matching icon.
  muteState = computed(() => muteStateOf(this.user(), this.odin.hasAudioInput()));

  protected readonly faHandWave = faHandWave;
}
